module.exports = __webpack_public_path__ + "img/OUBARI.1209916d.png";